// Routage. Chaque module déclare ses routes dans web/src/pages/<module>/routes.tsx.
import { useEffect } from 'react';
import { createBrowserRouter, Navigate, RouterProvider, useLocation } from 'react-router';
import { viderHorsLigne } from '../lib/horsLigne.ts';
import type { RouteObject } from 'react-router';
import { Coque } from './Coque.tsx';
import { FournisseurSession, useSessionRequete } from '../lib/session.tsx';
import { FournisseurNotifications, Chargement, EtatErreur } from '../components/ui.tsx';
import { ErreurApi } from '../lib/api.ts';
import { PageConnexion } from '../pages/connexion/PageConnexion.tsx';
import { routesAccueil } from '../pages/accueil/routes.tsx';
import { routesSites } from '../pages/sites/routes.tsx';
import { routesInterventions } from '../pages/interventions/routes.tsx';
import { routesEtudes } from '../pages/etudes/routes.tsx';
import { routesDocumentation } from '../pages/documentation/routes.tsx';
import { routesDevis } from '../pages/devis/routes.tsx';
import { routesConception } from '../pages/conception/routes.tsx';
import { routesAdmin } from '../pages/admin/routes.tsx';
import { routesLegal } from '../pages/legal/routes.tsx';
import { routesMemoire } from '../pages/memoire/routes.tsx';
import { routesBons } from '../pages/bons/routes.tsx';
import { routesContrats } from '../pages/contrats/routes.tsx';
import { routesGamme } from '../pages/gamme/routes.tsx';
import { PageIntrouvable } from '../pages/legal/PageIntrouvable.tsx';
import { EcranMfaImpose, EcranMotDePasseImpose } from '../pages/admin/PageCompte.tsx';

function Garde() {
  const s = useSessionRequete();
  const loc = useLocation();
  // Session refusée par le serveur (expirée, compte désactivé, second facteur requis) : on efface ce qui était gardé.
  const refusee = s.error instanceof ErreurApi && s.error.status === 401;
  useEffect(() => { if (refusee) viderHorsLigne().catch(() => {}); }, [refusee]);
  if (s.isLoading) return <div style={{ padding: 32 }}><Chargement lignes={4} libelle="Ouverture de la session…" /></div>;
  if (s.error instanceof ErreurApi && s.error.code === 'mfa_requis') {
    return <Navigate to={`/connexion?etape=code&retour=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  }
  if (s.error instanceof ErreurApi && s.error.status === 401) {
    return <Navigate to={`/connexion?retour=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  }
  if (s.isError || !s.data) return <div style={{ padding: 32 }}><EtatErreur erreur={s.error} reessayer={() => s.refetch()} /></div>;
  if (s.data.utilisateur.changerMotDePasse) return <EcranMotDePasseImpose moi={s.data} />;
  if (s.data.utilisateur.mfaAActiver) return <EcranMfaImpose moi={s.data} />;
  return <FournisseurSession moi={s.data}><Coque /></FournisseurSession>;
}

const enfants: RouteObject[] = [
  ...routesAccueil, ...routesSites, ...routesBons, ...routesContrats, ...routesInterventions, ...routesEtudes, ...routesDevis, ...routesConception, ...routesDocumentation, ...routesAdmin, ...routesLegal, ...routesMemoire, ...routesGamme,
  { path: '*', element: <PageIntrouvable /> },
];

const routeur = createBrowserRouter([
  { path: '/connexion', element: <PageConnexion /> },
  { path: '/', element: <Garde />, children: enfants },
]);

export function Application() {
  return (
    <FournisseurNotifications>
      <RouterProvider router={routeur} />
    </FournisseurNotifications>
  );
}
